module.exports = __webpack_public_path__ + "img/review-specs-and-drawings.0b661585.png";